import {action, computed, makeObservable, observable, reaction} from "mobx";
import {ChangeEvent} from "react";
import Store from '../store';

export interface RenewalStoreHandleFieldProps {
    fieldName: string,
    fieldIndex?: number|null,
}

class RenewalStore {
    companyInfo: any;
    updatedCompanyInfo: any;
    updatedFein: any;
    signedCompanyInfo = '';
    certificateOfStatus = false;


    /*All new stuff goes here*/

    constructor() {
        makeObservable(this, {
            updatedCompanyInfo: observable,
            updatedFein: observable,
            signedCompanyInfo: observable,
            certificateOfStatus: observable,
            setCertificateOfStatus: action.bound,
            hasValidSignature: computed,
            recordSignature: action.bound,
            invalidateSignature: action.bound,
            setFein: action.bound,
            handleFieldChange: action.bound,
            setCompanyInfo: action.bound,
            setUpdatedCompanyInfo: action.bound,
            replaceUpdatedCompanyInfoField:action.bound,
            replaceUpdatedCompanyInfoOfficer:action.bound,
            /*All new stuff goes here*/
        });
        reaction(() => JSON.stringify(this.updatedCompanyInfo), () => this.invalidateSignature());
    }

    get hasValidSignature() {
        return !!Store.getSignatureHash && this.signedCompanyInfo === JSON.stringify(this.updatedCompanyInfo);
    }

    setCertificateOfStatus(selected: boolean) {
        this.certificateOfStatus = selected;
    }

    recordSignature(signature: string, officerId: number | string | null, reviewedCompany: any) {
        if (JSON.stringify(reviewedCompany) !== JSON.stringify(this.updatedCompanyInfo)) {
            throw new Error('Company details changed while saving. Please review and sign again.');
        }
        this.signedCompanyInfo = JSON.stringify(reviewedCompany);
        Store.setSignatureHash(signature);
        Store.setSelectedOfficer(officerId);
    }

    invalidateSignature() {
        this.signedCompanyInfo = '';
        Store.setSignatureHash('');
        Store.setSelectedOfficer(null);
        if (Store.getRenewStep === 2) Store.setRenewStep(1);
    }

    /*Old stuff below here*/

    setFein = (fein: any) => {
        this.updatedFein = fein;
    }

    get getFein(){
        return this.updatedFein;
    }

    setCompanyInfo = (companyInfo: any) => {
        this.invalidateSignature();
        Store.setRenewStep(1);
        this.companyInfo = companyInfo;
        this.certificateOfStatus = false;
    }

    setUpdatedCompanyInfo = (updatedCompanyInfo: any) => {
        this.updatedCompanyInfo = updatedCompanyInfo;
    }

    replaceUpdatedCompanyInfoField = (field:string, data: any) => {
        this.updatedCompanyInfo[field] = data;
    }

    replaceUpdatedCompanyInfoOfficer = (index:number, data:any) => {
        let tmp = JSON.parse(JSON.stringify(this.updatedCompanyInfo['officers']));
        tmp[index] = data;
        this.replaceUpdatedCompanyInfoField('officers', tmp);
    }

    get getCompanyInfo() {
        return this.companyInfo;
    }

    get getUpdatedCompanyInfo() {
        return this.updatedCompanyInfo;
    }

    handleFieldChange = (fieldData:RenewalStoreHandleFieldProps, event: ChangeEvent<HTMLTextAreaElement|HTMLInputElement>) => {
        let newValue = (event.target as HTMLInputElement).value;
        let tmp = this.getUpdatedCompanyInfo;
        if(fieldData.fieldName === 'officers'){
            tmp[fieldData.fieldName][fieldData.fieldIndex!] = newValue;
        }else{
            tmp[fieldData.fieldName] = newValue;
        }

        // const delta = diff.getDiff(updatedCompanyInfo, companyInfo);
        // console.log(delta);
        this.setUpdatedCompanyInfo(tmp);
        // console.log(updatedCompanyInfo);
    };

}

export default new RenewalStore();
